import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home, Bug, ShieldAlert, Activity, Users } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
const activities = [{
  title: 'Tsetse Fly Control',
  description: 'Deploying traps and targets to reduce tsetse fly populations in endemic areas.',
  icon: Bug
}, {
  title: 'Disease Surveillance',
  description: 'Monitoring human and animal populations for early detection of trypanosomiasis.',
  icon: Activity
}, {
  title: 'Research Coordination',
  description: 'Collaborating with research institutions to develop better control methods.',
  icon: ShieldAlert
}, {
  title: 'Community Sensitization',
  description: 'Educating communities on prevention and control measures.',
  icon: Users
}];
export function CoctuPage() {
  return <>
      <Header data-id="element-628" />
      <main className="flex-grow pt-[160px] md:pt-[148px] bg-gray-50 pb-20" data-id="element-629">
        <div className="relative text-white py-32 md:py-48 overflow-hidden" data-id="element-630">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1516467508483-a7212febe31a?w=1600&h=600&fit=crop")'
        }} data-id="element-631"></div>
          <div className="absolute inset-0 bg-uganda-green/80" data-id="element-632"></div>
          <div className="relative max-w-7xl mx-auto px-4 md:px-8" data-id="element-633">
            <div className="flex items-center text-sm text-green-100 mb-6" data-id="element-634">
              <Link to="/" className="hover:text-white flex items-center" data-id="element-635">
                <Home className="w-4 h-4 mr-1" data-id="element-636" /> Home
              </Link>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-637" />
              <span data-id="element-638">Programs & Projects</span>
              <ChevronRight className="w-4 h-4 mx-2" data-id="element-639" />
              <span className="text-white font-medium" data-id="element-640">COCTU</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-641">COCTU</h1>
            <p className="text-lg text-green-50 max-w-3xl leading-relaxed" data-id="element-642">
              Coordination Office for Control of Trypanosomiasis in Uganda.
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12" data-id="element-643">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 mb-12" data-id="element-644">
            <h2 className="text-2xl font-bold text-uganda-black mb-4" data-id="element-645">
              Our Mandate
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg" data-id="element-646">
              To coordinate tsetse and trypanosomiasis control efforts across
              Uganda, ensuring the protection of human and animal health to
              boost agricultural productivity and rural livelihoods.
            </p>
          </div>

          <h2 className="text-2xl font-bold text-uganda-black mb-8" data-id="element-647">
            Key Activities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-648">
            {activities.map((activity, index) => {
            const Icon = activity.icon;
            return <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-649">
                  <div className="w-12 h-12 bg-green-100 text-uganda-green rounded-lg flex items-center justify-center mb-4" data-id="element-650">
                    <Icon className="w-6 h-6" data-id="element-651" />
                  </div>
                  <h3 className="text-lg font-bold text-uganda-black mb-2" data-id="element-652">
                    {activity.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-653">
                    {activity.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </main>
      <Footer data-id="element-654" />
    </>;
}